import { hasValue } from "@itk/typescript-utils";
import { Moment } from "moment";
import { compareDates } from "./date-utils";

export const handleNexAndPrevious = (selectedDateRange: [Moment | null, Moment | null], isPrevious: boolean): [Moment | null, Moment | null] => {
  if (hasValue(selectedDateRange[0]) && hasValue(selectedDateRange[1])) {
    const startDate = selectedDateRange[0];
    const endDate = selectedDateRange[1];

    if (!compareDates(startDate.toDate(), endDate.toDate(), "isSame")) {
      if (startDate.isoWeekday() === 1 && endDate.isoWeekday() === 7) {
        return [startDate.clone().add(isPrevious ? -7 : 7, "days"), endDate ? endDate.clone().add(isPrevious ? -7 : 7, "days") : null];
      } else if (startDate.date() === 1 && endDate.date() === endDate.clone().endOf("month").date() && startDate.isSame(endDate, "month")) {
        return [
          startDate.clone().add(isPrevious ? -1 : 1, "month"),
          endDate
            ? endDate
                .clone()
                .add(isPrevious ? -1 : 1, "month")
                .endOf("month")
            : null
        ];
      }
    } else {
      return [startDate.clone().add(isPrevious ? -1 : 1, "days"), endDate.clone().add(isPrevious ? -1 : 1, "days")];
    }
  }
  return [null, null];
};
